export default __webpack_public_path__ + "static/media/main_item_02.61e41203.png";